import React from 'react';
import '../index.css';

// Displayed when no subjects are present in the dashboard
const NoSubjects = () => {
  return (
    <div className='noSubs'>
      <h1>Add Subject to Mark Attendance</h1>
    </div>
  )
}

export default NoSubjects;
